export default __webpack_public_path__ + "static/media/contact_marek_prokop.2716421a.jpg";